
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class HUDOverlayEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;
        
        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawUI = () => {
             // Corners
             const size = 50 * scale;
             const padding = 20 * scale;
             
             // Top Left
             ctx.beginPath();
             ctx.moveTo(-width + padding, -height + padding + size);
             ctx.lineTo(-width + padding, -height + padding);
             ctx.lineTo(-width + padding + size, -height + padding);
             ctx.stroke();

             // Target Box (animated)
             const boxSize = 100 * scale * (1 + Math.sin(curTime) * 0.1);
             ctx.strokeRect(-boxSize/2, -boxSize/2, boxSize, boxSize);
             
             // Crosshair
             ctx.beginPath();
             ctx.moveTo(-10 * scale, 0); ctx.lineTo(10 * scale, 0);
             ctx.moveTo(0, -10 * scale); ctx.lineTo(0, 10 * scale);
             ctx.stroke();

             // Rotating rings
             ctx.beginPath();
             ctx.arc(0, 0, 150 * scale, curTime, curTime + Math.PI * 0.5);
             ctx.stroke();
             ctx.beginPath();
             ctx.arc(0, 0, 160 * scale, -curTime * 0.5, -curTime * 0.5 + Math.PI);
             ctx.stroke();
        };

        const draw = () => {
            ctx.save();
            ctx.globalAlpha *= 0.5 / layerIndex;
            drawUI();
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
